import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InMemoryCacheService } from 'src/app/common';

@Injectable({
  providedIn: 'root'
})
export class SeoInterceptorService implements HttpInterceptor {

  constructor(private cache: InMemoryCacheService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add your code logic here

    if (
      request.url.toLocaleLowerCase().includes('api/v1/onpage') || 
      request.url.toLocaleLowerCase().includes('api/v1/serps') || 
      request.url.toLocaleLowerCase().includes('api/v1/reviews') || 
      request.url.toLocaleLowerCase().includes('api/v1/contentanalysis') || 
      request.url.toLocaleLowerCase().includes('api/v1/keywords') || 
      request.url.toLocaleLowerCase().includes('api/v1/marketanalysis') || 
      request.url.toLocaleLowerCase().includes('api/v1/competitors') || 
      request.url.toLocaleLowerCase().includes('api/v1/amazon') || 
      request.url.toLocaleLowerCase().includes('api/v1/bing') || 
      request.url.toLocaleLowerCase().includes('api/v1/businessdata') || 
      request.url.toLocaleLowerCase().includes('api/v1/competitors') || 
      request.url.toLocaleLowerCase().includes('api/v1/backlinks') || 
      request.url.toLocaleLowerCase().includes('api/v1/anchors') || 
      request.url.toLocaleLowerCase().includes('api/v1/referringdomains') ||
      request.url.toLocaleLowerCase().includes('api/v1/aicontent')) {
        if (request.body) {
          request.body.userId = this.cache?.userId;
        }
    }

    
    return next.handle(request);
  }
}